<div
  class="grid items-center w-full grid-cols-3 text-center text-white bg-top bg-scores h-238 rounded-10 max-sm:rounded-5 max-sm:h-81 justify-evenly"
>
  <!-- Home Team Container -->
  <!-- (click)="openTeam(infoMatch.homeTeam)" -->
  <a [routerLink]="[getHomeTeamRedirectionUrl()]">
    <div
      class="flex flex-col items-center gap-2 cursor-pointer font-roboto-800 text-20 hover:underline max-sm:text-10 max-sm:gap-1"
    >
      <div class="feature-logo">
        <!-- [src]="
          infoMatch.homeTeam?.logo
            ? infoMatch.homeTeam.logo
            : urlImg + 'default.png'
        " -->
        <img alt="homeTeam-logo" [src]="getHomeTeamImage()" />
      </div>
      {{ getHomeTeamName() | uppercase }}
      <!-- {{
      infoMatch.homeTeam?.name || infoMatch.homeTeam?.player1?.knownName || "NA"
        | uppercase
    }} -->
    </div>
  </a>

  <!-- Match Score and Status -->
  <div class="text-center">
    <div
      class="font-pilat-900 text-32 max-sm:text-14"
      [class.efect-inlive]="isLiveGame()"
    >
      {{ getHomeScore() }}
      <!-- {{
        infoMatch.statusId === 100 || infoMatch.statusId === 2
          ? infoMatch.homeScores?.scoreFinal ||
            infoMatch.homeTeam?.scores?.current
          : 0
      }} -->
      <span class="mx-2">-</span>
      {{ getAwayScore() }}
      <!-- {{
        infoMatch.statusId === 100 || infoMatch.statusId === 2
          ? infoMatch.awayScores?.scoreFinal ||
            infoMatch.awayTeam?.scores?.current
          : 0
      }} -->
    </div>
    <div class="mt-1 font-roboto-700 text-20 max-sm:text-10">
      <!-- {{ infoMatch.score.status.text | uppercase }} -->
      {{ getMatchTag() | translate | uppercase }}
    </div>
    <div
      class="flex items-center justify-center gap-1 mt-4 font-roboto-500 text-17 max-sm:text-8 max-sm:mt-1"
    >
      <!-- [src]="urlIcon + 'calendar-white.svg'" -->
      <img alt="calendar" class="max-sm:w-[10px]" [src]="getCalendarIcon()" />
      {{ getMatchDate() }}
      <!-- {{ infoMatch.score?.matchDate }}
      {{ infoMatch.statusId === 2 ? infoMatch.score?.matchTime : "" }} -->
    </div>
  </div>

  <!-- Away Team Container -->
  <!-- (click)="openTeam(infoMatch.awayTeam)" -->
  <a [routerLink]="[getAwayTeamRedirectionUrl()]">
    <div
      class="flex flex-col items-center gap-2 text-center cursor-pointer font-roboto-800 text-20 hover:underline max-sm:text-10 max-sm:gap-1"
    >
      <!-- Away Team Logo -->
      <div class="feature-logo">
        <!-- [src]="
        infoMatch.awayTeam?.logo
          ? infoMatch.awayTeam.logo
          : urlImg + 'default.png'
      " -->
        <img alt="awayTeam-logo" [src]="getAwayTeamImage()" />
      </div>
      <!-- Away Team Name -->
      {{ getAwayTeamName() | uppercase }}
      <!-- {{
      infoMatch.awayTeam?.name || infoMatch.awayTeam?.player1?.knownName || "NA"
        | uppercase
    }} -->
    </div>
  </a>
</div>
